// extracted by css-extract-rspack-plugin
export default {"actions":"actions-ABXHRz"};